import * as yup from 'yup';

export const validateReferringMDForm = yup.object({
  cardiologist: yup.string(),
  cardiologistphone: yup.string(),
  cardiologistemail: yup.string().trim().email('Email must be a valid email'),
  pcp: yup.string(),
  pcpphone: yup.string(),
  pcpemail: yup.string().trim().email('Email must be a valid email'),
  obgyn: yup.string(),
  obgynphone: yup.string(),
  obgynemail: yup.string().trim().email('Email must be a valid email')
});
